// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CheckboxRow__container-cd1d2f {
  display: flex;
  justify-content: space-between;
}

.CheckboxRow__checkbox-view-a95317 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  margin-inline-start: 24px;
  border-radius: 50%;
  border: 2px solid var(--base-60);
  box-sizing: border-box;
}

.CheckboxRow__checkbox-ea27aa {
  display: none;
}

.CheckboxRow__checkbox-ea27aa:checked + .CheckboxRow__checkbox-view-a95317 {
  border: none;
  background-color: var(--brand-primary-40);
}

.CheckboxRow__disabled-a0d608 {
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/components/ShareDataView/CheckboxRow/CheckboxRow.styles.m.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,gCAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,YAAA;EACA,yCAAA;AACF;;AAEA;EACE,YAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  justify-content: space-between;\n}\n\n.checkbox-view {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 24px;\n  height: 24px;\n  margin-inline-start: 24px;\n  border-radius: 50%;\n  border: 2px solid var(--base-60);\n  box-sizing: border-box;\n}\n\n.checkbox {\n  display: none;\n}\n\n.checkbox:checked + .checkbox-view {\n  border: none;\n  background-color: var(--brand-primary-40);\n}\n\n.disabled {\n  opacity: 0.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CheckboxRow__container-cd1d2f`,
	"checkbox-view": `CheckboxRow__checkbox-view-a95317`,
	"checkboxView": `CheckboxRow__checkbox-view-a95317`,
	"checkbox": `CheckboxRow__checkbox-ea27aa`,
	"disabled": `CheckboxRow__disabled-a0d608`
};
module.exports = ___CSS_LOADER_EXPORT___;
